import React from 'react';
import Link from 'gatsby-link';
import Obfuscate from 'react-obfuscate';
import { FaPaperPlaneO, FaWrench } from 'react-icons/lib/fa';

const ForHomePageContentEn = (
  <div className="c-remark-screen__message">
    <p>
      <b>I'm glad</b><br /> that you're interested in my stuff.
    </p>
    <p>
    There's something I want you to remember while you're going over the website.
    </p>
    <p>
        At present, I'm available for consultancies related to seismic design, seismic assessment and/or numerical  modelling  of  RC  structures.
       </p>
    <p>
      If  you  realize  that  I  would  be  a  good  fit,  drop  me  a  message  at  <b><Obfuscate email='robertogentile90@gmail.com' /></b>
    </p>
    <p>
      Thank you. I hope you enjoy my website.
    </p>
  </div>
);

const ForHomePageContentIt = (
  <div className="c-remark-screen__message">
    <p>
      <b>Grazie</b><br /> per il tuo interesse nel mio lavoro.
    </p>
    <p>
    Mentre scorri le pagine di questo sito ricordati che...
    </p>
    <p>
    Sono disponibile per consulenze relative al progetto sismico di strutture in cemento armato, valutazione di vulnerabilità di strutture esistenti e/o modellazione numerica.
       </p>
    <p>
      Se pensi che possa essere la persona giusta, inviami un messaggio a <b><Obfuscate email='robertogentile90@gmail.com' /></b>
    </p>
    <p>
      Grazie. Spero che il mio sito web sia per te una risorsa utile.
    </p>

  </div>
);

const RemarkScreen = (props) => {
  const links = [
    { path: 'toolbox', icon: FaWrench }
  ];

  return (
    <div className={`c-remark-screen ${props.isActive && 'c-remark-screen--is-active'}`}>
        {((props.locationPathName === '/en/')||(props.locationPathName === '/')) ? ForHomePageContentEn : ForHomePageContentIt}
        {(props.locationPathName === '/it/')||(props.locationPathName === '/') &&
        <div className="c-remark-screen__links">
          {
            links.map((link) => (
              <Link
                key={link.path}
                className="c-remark-screen__link"
                to={`/${link.path}/`}
                onClick={props.onClick}
                tabIndex={props.isActive ? '1' : '-1'}
              >
                <link.icon /> {link.path}
              </Link>)
            )
          }
        </div>
      }

      <div className="c-remark-screen__bg"></div>
    </div>
  )
};

export default RemarkScreen;



// WEBPACK FOOTER //
// ./src/components/RemarkScreen.jsx